export const faqData = [
  {
    question: "What is INET-GPT?",
    answer:
      "INET-GPT is an AI-powered learning platform designed to help aspirants crack the Indian Navy Entrance Test (INET). It covers all essential subjects like English, General Science, Mathematics, Reasoning, and Current Affairs, while also supporting SSB/NSB interview preparation.",
  },
  {
    question: "How does INET-GPT support INET written exam preparation?",
    answer:
      "INET-GPT provides: Chapter-wise concepts in English, Science, Maths, and Reasoning; Topic-wise practice with instant AI-driven feedback; Previous year paper analysis and pattern insights; AI-generated mock tests and revision quizzes; Daily defence-oriented current affairs; Short tricks, tips, and time-saving techniques.",
  },
  {
    question: "Does INET-GPT help with NSB/SSB interview preparation too?",
    answer:
      "Yes. INET-GPT includes tools to improve spoken English, reasoning ability, and fitness—critical for NSB and SSB selection. For detailed personality assessment, mock interviews, and officer-like quality development, you can use our advanced interview training platform: SSB-GPT.",
  },
  {
    question: "Is INET-GPT suitable for first-time aspirants?",
    answer:
      "Absolutely! INET-GPT is ideal for both first-timers and repeat candidates. It adapts to your preparation level and personalizes your learning journey based on your strengths and weaknesses.",
  },
  {
    question: "Can I ask doubts anytime?",
    answer:
      "Yes! With 24×7 AI doubt resolution, you can ask anything—from a tough reasoning puzzle to a science concept—and get instant, clear guidance.",
  },
  {
    question: "Who created INET-GPT?",
    answer:
      "INET-GPT is built by Arcaptor Technologies, a team of retired Navy officers, AI developers, defence trainers, and educationists—united in their mission to prepare future Naval leaders with cutting-edge technology.",
  },
  {
    question: "Is INET-GPT free?",
    answer:
      "INET-GPT offers a free trial with limited content. To unlock full features—including mocks, feedback, and personalized plans—subscription starts at just ₹499.",
  },
  {
    question: "Can I use INET-GPT on mobile?",
    answer:
      "Yes! INET-GPT is mobile-friendly. You can access it through your browser, and a dedicated mobile app will soon be available on the Play Store and App Store.",
  },
  {
    question: "Does INET-GPT help with physical preparation?",
    answer:
      "Yes. Our AI fitness coach Vikram provides customized fitness routines and diet tips. You can also connect with real trainers for guided fitness sessions through Alpha Regiment.",
  },
  {
    question: "Is the content in INET-GPT regularly updated?",
    answer:
      "Definitely. All content is synced with the latest INET syllabus and Navy trends. Daily current affairs, GK updates, and expert-vetted material ensure your prep stays current.",
  },
  {
    question: "Can I get personal mentorship on INET-GPT?",
    answer:
      "Yes. Through Alpha Regiment, you can connect with recommended Navy candidates and retired officers for 1-on-1 guidance. Personalized mentorship is available for both written and NSB/SSB stages.",
  },
  {
    question: "How do I get started with INET-GPT?",
    answer: `Just visit ${process.env.REACT_APP_REDIRECT_LINK}/inet-gpt, sign up, and start preparing to join the elite ranks of the Indian Navy!`,
  },
];
